import React, { useContext, useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router";
import app from "./base";
import { db } from "./base";
import { AuthContext } from "./Auth";
import Layout from "./layout";

const SignUp = ({ history }) => {
  const { currentUser } = useContext(AuthContext);
  const [user, setUser] = useState("");
  const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
    if (currentUser !== null) {
      db.collection("users")
        .doc(currentUser.uid)
        .get()
        .then((doc) => {
          setUser(doc.data().role);
        });
      setIsloading(false);
    }
  }, []);

  const handleSignUp = useCallback(
    async (event) => {
      event.preventDefault();
      const { email, password, username, role } = event.target.elements;
      try {
        await app
          .auth()
          .createUserWithEmailAndPassword(email.value, password.value)
          .then((cred) => {
            return db.collection("users").doc(cred.user.uid).set(
              {
                email: email.value,
                username: username.value,
                role: role.value,
              },
              { merge: true }
            );
          });
        history.push("/");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  if (isLoading) {
    return <p className="loading">Chargement...</p>;
  }

  return (
    <Layout title={"Création d'un compte"}>
      <div className="page-login-signup">
        <form onSubmit={handleSignUp}>
          <input name="username" type="text" placeholder="Nom d'utilisateur" />
          <input name="email" type="email" placeholder="Email" />
          <input name="password" type="password" placeholder="Password" />
          <select name="role">
            <option value="">-- Role --</option>
            <option value="admin">Admin</option>
            <option value="client">Client</option>
          </select>
          <button type="submit">Créer le compte</button>
        </form>
      </div>
    </Layout>
  );
};

export default withRouter(SignUp);
